import { Box, Button, Heading, Image, Text } from '@chakra-ui/react'
import React from 'react'

function HomePageComponent({data}) {
  return (
    <Box width="80%" margin="auto" display="flex" p="2rem 1rem" justifyContent="space-evenly" alignItems={"center"}>
        <Box>
            <Image width="400px" src={data.src} alt=""/>
        </Box>
        <Box textAlign="left" w="40%">
            <Heading as="h1" mb={8} size="xl" fontWeight="400">{data.heading}</Heading>
            <Text mb="8">{data.des}</Text>
            <Button colorScheme='teal' variant='outline' p={8}>{data.btn}</Button>
        </Box>
    </Box>
  )
}

export default HomePageComponent